import { createSlice } from '@reduxjs/toolkit'

import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const initialState = {
  registrations: [],
  allRegistrations: [],
  selectedRegistration: null,
  ownRegistration: null,
  results: null,
  loading: false,
  error: null,
  view: 'all',
  registrationsFetched: false
}

const snacks = createSlice({
  name: 'snacks',
  initialState,
  reducers: {
    setRegistrations (state, action) {
      return {
        ...state,
        registrations: action.payload
      }
    },
    setAllRegistrations (state, action) {
      return {
        ...state,
        allRegistrations: action.payload
      }
    },
    setSelectedRegistration (state, action) {
      return {
        ...state,
        selectedRegistration: action.payload
      }
    },
    setOwnRegistration (state, action) {
      return {
        ...state,
        ownRegistration: action.payload,
        registrationsFetched: true
      }
    },
    setLoading (state, action) {
      return {
        ...state,
        loading: action.payload
      }
    },
    setError (state, action) {
      return {
        ...state,
        error: action.payload
      }
    },
    upsertRegistration (state, action) {
      const updated = action.payload
      const current = Array.isArray(state.allRegistrations) ? state.allRegistrations : []
      const existingIndex = current.findIndex((r) => r.id === updated.id)
      if (existingIndex >= 0) {
        const next = [...current]
        next[existingIndex] = updated
        return { ...state, allRegistrations: next }
      }
      return { ...state, allRegistrations: [...current, updated] }
    },
    removeRegistration (state, action) {
      const id = action.payload
      const current = Array.isArray(state.allRegistrations) ? state.allRegistrations : []
      return {
        ...state,
        allRegistrations: current.map((r) => r.id === id ? { ...r, status: 'disabled' } : r)
      }
    },
    setResults (state, action) {
      return { ...state, results: action.payload }
    },
    selectSnacksView (state, action) {
      return { ...state, view: action.payload }
    }
  }
})

const persistConfig = {
  key: 'snacks',
  storage,
  blacklist: ['registrations', 'allRegistrations', 'registrationsFetched']
}

export const {
  setRegistrations,
  setAllRegistrations,
  setSelectedRegistration,
  setOwnRegistration,
  setResults,
  setLoading,
  setError,
  upsertRegistration,
  removeRegistration,
  selectSnacksView
} = snacks.actions

export const SnacksReducer = persistReducer(persistConfig, snacks.reducer)
